import { useHasExperimentVariantIf } from "@bokio/components/Experiment/Experiment";

import { HelpMessageForm as HelpMessageFormLegacy } from "./HelpMessageForm";
import { HelpMessageFormRedesigned } from "./HelpMessageFormRedesigned";

import type { MenuHelpMessageFormValues } from "./Help/Help";
import type { FileWithPreview } from "@bokio/elements/FileUploader/components/FilePreview/FilePreview";
import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FieldValidationResult, ValidatorResult } from "@bokio/shared/validation/entityValidator";
import type { Dispatch, FC, SetStateAction } from "react";

export const SUPPORT_FORM_REDESIGN_EXPERIMENT_NAME = "SupportFormRedesign";
export const SUPPORT_FORM_REDESIGN_VARIANT_ID = "437480db-bf55-41e8-9a9f-9cbec695a8f5";

interface HelpMessageFormSwitcherProps {
	isOpened: boolean;
	modalView?: boolean;
	formData: MenuHelpMessageFormValues;
	setFormData: (reducer: (oldFormData: MenuHelpMessageFormValues) => MenuHelpMessageFormValues) => void;
	isLoggedIn: boolean;
	validation: ValidatorResult & {
		isValid: boolean;
		errors?: FieldValidationResult[] | undefined;
	};
	areas: m.Contracts.SupportArea[];
	contactTimePreferences?: m.Contracts.CallTimePreference[];
	files: FileWithPreview[];
	setFiles: Dispatch<SetStateAction<FileWithPreview[]>>;
	/** Route template the user is on now (e.g. "/:company/invoicing"). Forwarded to redesigned form for breakpoint inspection. */
	currentRoute?: string;
	/** Exact URL incl. query string; redesigned form logs this for breakpoint inspection. */
	currentExactUrl?: string;
}

export const HelpMessageFormSwitcher: FC<HelpMessageFormSwitcherProps> = props => {
	const { hasVariant: showRedesignedForm } = useHasExperimentVariantIf(
		SUPPORT_FORM_REDESIGN_EXPERIMENT_NAME,
		SUPPORT_FORM_REDESIGN_VARIANT_ID,
		props.isLoggedIn,
	);

	if (showRedesignedForm) {
		return <HelpMessageFormRedesigned {...props} />;
	}

	return <HelpMessageFormLegacy {...props} />;
};
